import * as Yup from "yup";

import { HuseierneMembershipStatus } from "Components/Form/Partner/partnerFormValuesInterfaces";
import { TextManager } from "Components/TextContext";
import { zipCodeRegex } from "Features/CheckPrice/Products/RiskProducts/riskProductsUtils";
import { MonthlyRent } from "Store/interfaces/products/checkout/riskProducts/houseProducts/RentalProduct";
import { RentalProductIntroFormValues } from "../rentalFormValuesInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<RentalProductIntroFormValues> => {
    const { getText } = TextManager;

    return Yup.object({
      postNumber: Yup.string()
        .required(getText("rentalform.validation.postnumber_required"))
        .matches(
          zipCodeRegex,
          getText("rentalform.validation.postnumber_invalid"),
        )
        .test(
          "postnumber is valid",
          getText("cabinform.validation.postnumber_invalid"),
          function () {
            return this.parent.validPostNumber;
          },
        ),
      city: Yup.string(),
      validPostNumber: Yup.boolean(),
      monthlyRent: Yup.mixed<MonthlyRent>().required(
        getText("rentalform.validation.monthlyrent"),
      ),
      huseierneMembershipStatus:
        Yup.mixed<HuseierneMembershipStatus>().required(
          getText("partnerhuseierne.validation.huseiernemembershipstatus"),
        ),
    }).defined();
  };
